import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map as _map } from 'lodash';

import {
  Item,
  NavigationLink,
  SubNavigationContainer,
  SubNavigation,
  SubNavigationItem,
  SubNavigationLink,
  OpenNavigationLinkIcon,
  CloseNavigationLinkIcon
} from './NavigationItem.css.js';

class NavigationItem extends Component {
  constructor() {
    super();

    this.toggleSubNavigation = this.toggleSubNavigation.bind(this);
  }
  state = {
    isSubNavigationOpen: false,
  }

  renderSubNavigation(title, subNavigationItems) {
    const items = (subNavigationItems) => (
      _map(subNavigationItems, (subNavigationItem) => (
          <SubNavigationItem>
            <SubNavigationLink href={subNavigationItem.link}>{subNavigationItem.label}</SubNavigationLink>
          </SubNavigationItem>
        )
      )
    );

    return (
      <SubNavigationContainer
        id={title.toLowerCase().replace(` `, ``) + `-link`}
        data-subnavigation={title}
      >
        <SubNavigation>
          {items(subNavigationItems)}
        </SubNavigation>
      </SubNavigationContainer>
    );
  }

  renderDropdownIcon() {
    const { showDropdownIcon } = this.props.config;
    const { label } = this.props.content;

    if (!showDropdownIcon) {
      return null;
    }

    return (
      <React.Fragment>
        {(!this.state.isSubNavigationOpen) ? (
          <OpenNavigationLinkIcon
            config={{
              color: `white`,
              height: `25px`,
            }}
            content={{
              title: `Open ${label} Icon`,
              type: `down-arrow`,
            }}
          />
        ) : (
          <CloseNavigationLinkIcon
            config={{
              color: `white`,
              height: `25px`,
            }}
            content={{
              title: `Open ${label} Icon`,
              type: `up-arrow`,
            }}
          />
        )}
      </React.Fragment>
    )
  };

  toggleSubNavigation() {
    if (!!this.state.isSubNavigationOpen) {
      this.setState({ isSubNavigationOpen: false });
    } else {
      this.setState({ isSubNavigationOpen: true });
    }
  }

  render() {
    const { label, link, subNavigationItems } = this.props.content;

    return (
      <React.Fragment>
        {(!!subNavigationItems) ? (
          <Item onClick={this.toggleSubNavigation}>
            <NavigationLink>
              {label}

              {this.renderDropdownIcon()}
            </NavigationLink>
            
            {(!!this.state.isSubNavigationOpen) ? this.renderSubNavigation(label, subNavigationItems) : null}
          </Item>
        ) : (
          <Item><NavigationLink href={link}>{label}</NavigationLink></Item>
        )}
      </React.Fragment>
    );
  }
}

NavigationItem.propTypes = {
  config: PropTypes.shape({
    showDropdownIcon: PropTypes.bool,
  }),
  content: PropTypes.shape({
    label: PropTypes.string.isRequired,
    link: PropTypes.string,
    subNavigationItems: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        link: PropTypes.string,
      }),
    ),
  }),
};

NavigationItem.defaultProps = {
  config: {
    showDropdownIcon: true,
  },
};

export default NavigationItem;